type PCEventCallback = (...args: unknown[]) => void;

export class PCAppEventHandler {
  private events = new Map<string, PCEventCallback[]>();
  private registrationEvents = new Map<string, PCEventCallback[]>();

  constructor(private iframeEl: HTMLIFrameElement) {}

  fire(name: string, ...args: unknown[]) {
    const data = {
      eventName: name,
      eventValues: JSON.parse(JSON.stringify(args)),
    };
    try {
      this.iframeEl.contentWindow?.postMessage(data, "*");
    } catch (err) {
      const msg = JSON.stringify({ data });
      throw new AggregateError([err], `postMessage failed: Launcher PCAppEventHandler: ${msg}`);
    }
  }

  hasEvent(name: string) {
    return this.events.has(name);
  }

  on(name: string, callback: PCEventCallback) {
    let events = this.events.get(name);
    if (!events) {
      events = [];
    }
    events.push(callback);
    this.events.set(name, events);

    const registrationCallbacks = this.registrationEvents.get(name);
    if (registrationCallbacks) {
      for (const callback of registrationCallbacks) {
        callback();
      }
    }
  }

  post(evt: { eventName: string; eventValues?: unknown[] }) {
    const callbacks = this.events.get(evt.eventName);
    if (callbacks) {
      for (const callback of callbacks) {
        if (evt.eventValues) {
          callback(...evt.eventValues);
        } else {
          callback();
        }
      }
    }
  }

  onRegistration(name: string, callback: PCEventCallback) {
    let registrationEvents = this.registrationEvents.get(name);
    if (!registrationEvents) {
      registrationEvents = [];
    }
    registrationEvents.push(callback);
    this.registrationEvents.set(name, registrationEvents);
    if (this.hasEvent(name)) {
      callback();
    }
  }
}
